module.exports = __webpack_public_path__ + "static/media/  (50).a07f8466.jpg";